import {SyntheticEvent} from 'react';

const callName = "event_" + (new Date()).getTime();

type EventType = Event & {originalEvent: Event | SyntheticEvent, field: string, value: any};

type CallbackTypes = (event: EventType) => any;

class SaveChangesEvent extends Event implements EventType {
    field: string;
    originalEvent: Event | SyntheticEvent;
    value: any;
}

export const eventBasedFunction = (cb: (event: EventType) => any): CallbackTypes => {
    return new Function("action", "return function " + callName + "(...args){ action(...args); };")(cb);
};

export const saveChanges = (cb: CallbackTypes) => {
    return function(field: string, value: any, originalEvent?: Event|SyntheticEvent) {
        if (cb.name === callName) {
            if (originalEvent instanceof Event || (originalEvent?.hasOwnProperty && originalEvent?.hasOwnProperty("nativeEvent"))) {
                const event = new SaveChangesEvent("saveChanges");
                event.originalEvent = originalEvent;
                event.value = value;
                return cb(event);
            } else {
                console.error("originalEvent param is not an Event for saveChanges!");
            }
        } else {
            console.error("Not event based function in the saveChanges callback!");
        }
    }
}

export const saveChangesEvent = (cb: CallbackTypes) => saveChanges(eventBasedFunction(cb));